"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcurementRequestSchema = exports.CreateProcurementRequestSchema = exports.ProcurementRequestStatusSchema = exports.ProcurementRequestTypeSchema = void 0;
const zod_1 = require("zod");
/**
 * Procurement request — a row in `agenticpos-pos-dynamodb-procurement-requests-{stage}`,
 * written by procurement-service `POST /requests` (POS "Report out of stock",
 * "Request", "New product request", store supply) and listed by `GET /requests`.
 *
 * Every field beyond the identity/status core is optional: rows written before a
 * field existed simply lack it. Additive only — never make an existing field required.
 */
exports.ProcurementRequestTypeSchema = zod_1.z.enum([
    'out_of_stock',
    'customer_request',
    'new_product',
    'store_supply',
    'negative_stock',
]);
exports.ProcurementRequestStatusSchema = zod_1.z.enum(['pending', 'ordered', 'resolved', 'dismissed']);
/** Body of `POST /requests`. */
exports.CreateProcurementRequestSchema = zod_1.z.object({
    type: exports.ProcurementRequestTypeSchema,
    displayName: zod_1.z.string(),
    locationId: zod_1.z.string().optional(),
    terminalId: zod_1.z.string().nullable().optional(),
    employeeName: zod_1.z.string().nullable().optional(),
    productId: zod_1.z.string().optional(),
    variantId: zod_1.z.string().optional(),
    productName: zod_1.z.string().nullable().optional(),
    sku: zod_1.z.string().nullable().optional(),
    barcode: zod_1.z.string().nullable().optional(),
    thumbnail: zod_1.z.string().nullable().optional(),
    comment: zod_1.z.string().nullable().optional(),
    customerPhone: zod_1.z.string().nullable().optional(),
    /**
     * store_supply: the count left on the shelf (any number).
     * Every other type: units requested — a positive integer; anything else is stored as null.
     */
    quantity: zod_1.z.number().nullable().optional(),
    /** The store/warehouse the cashier asked to send it from (POS search "Request" panel). */
    sourceLocationId: zod_1.z.string().nullable().optional(),
    sourceLocationName: zod_1.z.string().nullable().optional(),
    supplyProductId: zod_1.z.string().nullable().optional(),
    supplyVariantId: zod_1.z.string().nullable().optional(),
});
/** The stored row, as returned by `POST /requests` and `GET /requests`. */
exports.ProcurementRequestSchema = exports.CreateProcurementRequestSchema.extend({
    tenantId: zod_1.z.string(),
    requestId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    status: exports.ProcurementRequestStatusSchema,
    employeeId: zod_1.z.string().nullable().optional(),
    source: zod_1.z.string().nullable().optional(),
    statusComment: zod_1.z.string().nullable().optional(),
    statusUpdatedAt: zod_1.z.string().nullable().optional(),
    statusUpdatedBy: zod_1.z.string().nullable().optional(),
    joinedAfterOrder: zod_1.z.boolean().optional(),
    createdAt: zod_1.z.string(),
}).passthrough();
//# sourceMappingURL=procurement-request.schema.js.map